<template>
  <div class="disclaimer-wrapper" :class="{ closed: close }">
    <div class="disclaimer--inner">
      <!-- <h4>Weather for energy tracker</h4> -->
      <p>
        This map is without prejudice to the status of or sovereignty over any
        territory, to the delimitation of international frontiers and boundaries
        and to the name of any territory, city or area.
      </p>
      <button @click="click">I understand</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      close: false,
    };
  },
  methods: {
    click() {
      this.close = !this.close;
    },
  },
};
</script>

<style>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.disclaimer-wrapper {
  position: absolute;
  color: white;
  top: 0;
  left: 0;
  box-sizing: border-box;
  background: #0044ffd1;
  z-index: 999;
  padding: 50px;
  height: 100%;
  width: 100%;
  animation: fadeIn 1s ease;
  display: flex;
  justify-content: center;
}
.closed {
  animation: fadeOut 0.3s ease;
  display: none;
}
.disclaimer--inner {
  margin: auto;
}
.disclaimer--inner h4 {
  margin: 0 0 20px 0;
  font-size: 1.75rem;
  font-weight: 600;
}
.disclaimer--inner p {
  font-size: 1.25rem;
  line-height: 1.7rem;
  margin-bottom: 25px;
}
.disclaimer--inner button {
  padding: 10px 14px;
  background: transparent;
  border: 1px solid #fff;
  font-size: 1rem;
  cursor: pointer;
  color: #fff;
  transition: 0.2s linear;
}
.disclaimer--inner button:hover {
  background: #fff;
  color: #04f;
  transition: 0.2s linear;
}
@media screen and (min-width: 1480px) {
  .disclaimer--inner {
    width: 55%;
    padding-right: 0;
    padding-left: 0;
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (max-width: 1479px) and (min-width: 1280px) {
  .disclaimer--inner {
    width: calc(100vw - 55%);
  }
}
@media screen and (max-width: 1279px) and (min-width: 960px) {
  .disclaimer--inner {
    width: calc(100vw - 40%);
  }
}
@media screen and (max-width: 959px) and (min-width: 730px) {
  .disclaimer--inner {
    width: calc(100vw - 50%);
  }
}
@media screen and (max-width: 729px) {
  .disclaimer--inner {
    width: calc(100vw - 10%);
  }
}
</style>
